module.exports = __webpack_public_path__ + "img/21.9f8241fd.png";